import { current_color_scheme, set_color_scheme, subscribe_color_scheme_change } from 'color_scheme';

function paint_active(group) {
  const scheme = current_color_scheme();
  group.querySelectorAll('button[data-scheme]').forEach(btn => {
    if (btn.dataset.scheme === scheme) {
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');
    } else {
      btn.classList.remove('active');
      btn.setAttribute('aria-pressed', 'false');
    }
  });
}

document.addEventListener('turbolinks:load', function() {
  const groups = document.querySelectorAll('.color-scheme-switcher');
  if (!groups.length) return;

  const unsubscribes = [];

  groups.forEach(group => {
    paint_active(group);

    group.querySelectorAll('button[data-scheme]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        set_color_scheme(btn.dataset.scheme);
      });
    });

    unsubscribes.push(subscribe_color_scheme_change(() => paint_active(group)));
  });

  const cleanup = () => {
    unsubscribes.forEach(u => { try { u(); } catch (e) { /* ignore */ } });
    document.removeEventListener('turbolinks:before-cache', cleanup);
  };
  document.addEventListener('turbolinks:before-cache', cleanup);
});
